export const emptySetText = 'No properties found for this agent.';

export const searchPlaceholder = 'search by address...';
